
import '../Search/Search.css';

import List from "../List/List";
import Filter from "../Filter/Filter"
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useState, useRef } from 'react';
import { logDOM } from '@testing-library/react';


export default function Search(props) {

    const listParams = useRef([{ type: "ingredient" }]);
    const [searchRes, setSearchRes] = useState([])
    const [inputValue, setInputValue] = useState('');

    console.log(listParams.current);

    const handleInputChange = (event) => {
        console.log(event);
        setInputValue(event.target.value);
    }

    function toOneObj(arr) {
        const obj = arr.reduce((result, current) => {
            return { ...result, ...current };
        }, {});
        return obj
    }

    async function getRecipes() {
        let params = toOneObj(listParams.current)

        const queryString = await Object.entries(params)
            .map(([key, value], index) => index === 0 ? "" :
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");

        console.log(queryString);
        const baseURL = `${process.env.REACT_APP_SERVER_URL}/complexSearch?query=${inputValue}${queryString}&number=10`;
        console.log("url base", baseURL);

        const response = await fetch(baseURL,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'

                },
            })
        const searchRes = await response.json();
        if (searchRes && response.status) {
            setSearchRes(searchRes);
        }
        else {
            setSearchRes([]);
            console.log("empty data", response)
        }

        console.log(searchRes);
    }
    async function getIngredients(element) {
        const baseURL = `${process.env.REACT_APP_SERVER_URL}/searchIngredients?query=${inputValue}&number=10`;
        console.log("url base", baseURL);

        const response = await fetch(baseURL,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'

                },
            })

        const searchRes = await response.json();
        if (searchRes && response.status) {
            setSearchRes(searchRes.results);
            console.log(searchRes, "test");
        }
        else {
            setSearchRes([]);
            console.log("empty data", response)
        }

        console.log(searchRes);
    }


    function getData(element) {
        element.preventDefault();
        if (listParams.current.length !== 0) {
            if (listParams.current[0].type === 'ingredient') {
                getIngredients();
            }
            else {
                getRecipes();
            }
        }
    }

    console.log(listParams.current);
    return (
        <>
            <div className="searchform">


                <Form className="form">
                    <h3 className="h3-title">Let's find what you want :</h3>
                    <Form.Control size="lg" type="text" onChange={handleInputChange} placeholder="Search..." required />

                    <Filter searchRes={searchRes} list={listParams} />
                    <Button className="searchbutton" variant="primary" type="submit" onClick={getData}>Search</Button>
                </Form>
                {(searchRes === [] || listParams.current.length === 0) ? <></> :
                    <List data={searchRes} type={(listParams.current[0].type === 'ingredient') ? "ingreidentSearch" : "recipeSearch"} />}
            </div>
        </>
    )
}
